import { useState } from "react";
import { Card, CardContent, CardMedia, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router";
import routes from "../../../routes";

type Props = {
  name: string;
  description?: string;
  developer?: string;
  id: string;
};

const truncateText = (
  text: string | undefined,
  maxLength: number,
  isExtraText: boolean,
) => {
  if (!text) return "";
  return isExtraText ? text : text.slice(0, maxLength);
};

const SolutionCard = ({ name, developer, description, id }: Props) => {
  const navigate = useNavigate();
  const [isExtraText] = useState(false);

  const maxDescriptionChars = 478;
  const truncatedDescriptionText = truncateText(
    description,
    maxDescriptionChars,
    isExtraText,
  );

  const maxNameChars = 56;
  const truncatedNameText = truncateText(name, maxNameChars, isExtraText);

  const maxDeveloperChars = 62;
  const truncatedDeveloperText = truncateText(
    developer,
    maxDeveloperChars,
    isExtraText,
  );

  return (
    <Card
      onClick={() => navigate(routes.solutions.view({ id }))}
      data-testid="solution-card-container"
      sx={{
        height: 600,
        width: 400,
        m: 2,
        "&:hover": { cursor: "pointer" },
      }}
      raised={true}
      component="article"
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          height: 140,
          overflow: "hidden",
        }}
      >
        <Typography
          align="left"
          gutterBottom
          variant="h5"
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {truncatedNameText}
          {!isExtraText && name && name.length > maxNameChars && "..."}
        </Typography>
        {developer !== "" && developer ? (
          <Typography align="left" gutterBottom variant="subtitle1">
            {truncatedDeveloperText}
            {!isExtraText &&
              developer &&
              developer.length > maxDeveloperChars &&
              "..."}
          </Typography>
        ) : null}
      </CardContent>
      <CardMedia>
        <Box
          sx={{
            paddingTop: "0%",
            objectFit: "scale-down",
            height: "214px",
            width: "100%",
            background:
              "linear-gradient(45deg, rgba(0,125,80,0.5) 0%, rgba(197,144,49,0.2) 100%)",
          }}
        />
      </CardMedia>
      <CardContent>
        <Typography
          minHeight={180}
          align="left"
          variant="body2"
          color="text.secondary"
          sx={{
            cursor: "pointer",
          }}
        >
          {truncatedDescriptionText}
          {!isExtraText &&
            description &&
            description.length > maxDescriptionChars &&
            "..."}
        </Typography>
        <Box
          sx={{
            paddingTop: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
          }}
        ></Box>
      </CardContent>
    </Card>
  );
};

export default SolutionCard;
